import { ROLES } from './roles.js';
import { MODULES } from './modules.js';
export const PERMISSIONS = {
    // Staff (renamed from USERS_*)
    STAFF_VIEW_ALL: 'staff.view.all',
    STAFF_VIEW_TEAM: 'staff.view.team',
    STAFF_CREATE: 'staff.create',
    STAFF_EDIT: 'staff.edit',
    STAFF_DELETE: 'staff.delete',
    STAFF_EXPORT: 'staff.export',
    // Roles & permission management
    ROLES_ASSIGN: 'roles.assign',
    ROLES_MANAGE: 'roles.manage',
    // Per-user module visibility (granted on Staff Detail Access page)
    MODULES_ASSIGN: 'modules.assign',
    // Profile (self-service)
    PROFILE_VIEW_OWN: 'profile.view.own',
    PROFILE_EDIT_OWN: 'profile.edit.own',
    // Departments (master)
    DEPARTMENTS_VIEW: 'departments.view',
    DEPARTMENTS_CREATE: 'departments.create',
    DEPARTMENTS_EDIT: 'departments.edit',
    DEPARTMENTS_DELETE: 'departments.delete',
    // Designations (master)
    DESIGNATIONS_VIEW: 'designations.view',
    DESIGNATIONS_CREATE: 'designations.create',
    DESIGNATIONS_EDIT: 'designations.edit',
    DESIGNATIONS_DELETE: 'designations.delete',
    // Attendance
    ATTENDANCE_VIEW_OWN: 'attendance.view.own',
    ATTENDANCE_VIEW_TEAM: 'attendance.view.team',
    ATTENDANCE_VIEW_ALL: 'attendance.view.all',
    ATTENDANCE_PUNCH: 'attendance.punch',
    ATTENDANCE_REGULARIZE: 'attendance.regularize',
    ATTENDANCE_MANAGE: 'attendance.manage',
    // WATI miss-punch WhatsApp reminder (HRMS Config > WATI tab)
    WATI_CONFIG_VIEW: 'wati_config.view',
    WATI_CONFIG_EDIT: 'wati_config.edit',
    // Face-scan keystores on the Rate API (HRMS Config > Face Scan Keystores tab)
    FACE_SCAN_KEYSTORES_VIEW: 'face_scan_keystores.view',
    FACE_SCAN_KEYSTORES_MANAGE: 'face_scan_keystores.manage',
    // Desktop screenshot tracker, proxied from the external tracker service (HRMS > Tracking)
    TRACKING_VIEW: 'tracking.view',
    TRACKING_MANAGE: 'tracking.manage',
    // Leave
    LEAVE_VIEW_OWN: 'leave.view.own',
    LEAVE_VIEW_TEAM: 'leave.view.team',
    LEAVE_VIEW_ALL: 'leave.view.all',
    LEAVE_REQUEST: 'leave.request',
    LEAVE_APPROVE: 'leave.approve',
    LEAVE_MANAGE: 'leave.manage',
    LEAVE_CANCEL: 'leave.cancel',
    LEAVE_ADMIN: 'leave.admin',
    LEAVE_CREDIT_VIEW: 'leave.credit.view',
    // Salary
    SALARY_VIEW_OWN: 'salary.view.own',
    SALARY_VIEW_ALL: 'salary.view.all',
    SALARY_MANAGE: 'salary.manage',
    SALARY_PROCESS: 'salary.process',
    // Loans & Advances
    LOAN_VIEW_OWN: 'loan.view.own',
    LOAN_MANAGE: 'loan.manage',
    // Penalty Management
    PENALTY_VIEW_OWN: 'penalty.view.own',
    PENALTY_VIEW_ALL: 'penalty.view.all',
    PENALTY_MANAGE: 'penalty.manage',
    // Paid Hours Management
    PAID_HOURS_VIEW_OWN: 'paid_hours.view.own',
    PAID_HOURS_VIEW_ALL: 'paid_hours.view.all',
    PAID_HOURS_MANAGE: 'paid_hours.manage',
    // Organization Hierarchy
    ORG_VIEW: 'org.view',
    ORG_MANAGE: 'org.manage',
    // Recruitment
    RECRUITMENT_VIEW: 'recruitment.view',
    RECRUITMENT_MANAGE: 'recruitment.manage',
    RECRUITMENT_CONFIG: 'recruitment.config',
    // Notice
    NOTICE_VIEW: 'notice.view',
    NOTICE_ACKNOWLEDGE: 'notice.acknowledge',
    NOTICE_MANAGE: 'notice.manage',
    // SOP (Standard Operating Procedures)
    SOP_VIEW: 'sop.view',
    SOP_ACKNOWLEDGE: 'sop.acknowledge',
    SOP_MANAGE: 'sop.manage',
    SOP_ASSIGN: 'sop.assign',
    SOP_COMPLIANCE_VIEW: 'sop.compliance.view',
    SOP_CONFIG: 'sop.config',
    // Assets
    ASSETS_VIEW: 'assets.view',
    ASSETS_CREATE: 'assets.create',
    ASSETS_EDIT: 'assets.edit',
    ASSETS_DELETE: 'assets.delete',
    ASSETS_ASSIGN: 'assets.assign',
    ASSETS_EXPORT: 'assets.export',
    ASSETS_OVERVIEW: 'assets.overview',
    ASSETS_MASTER: 'assets.master',
    ASSETS_VIEW_OWN: 'assets.view.own',
    // ID Management
    ID_CATEGORIES_MANAGE: 'id_categories.manage',
    ID_MANAGEMENT_VIEW: 'id_management.view',
    ID_MANAGEMENT_MANAGE: 'id_management.manage',
    MY_IDS_VIEW_OWN: 'my_ids.view.own',
    // Tasks
    TASK_VIEW_OWN: 'task.view.own',
    TASK_VIEW_TEAM: 'task.view.team',
    TASK_VIEW_ALL: 'task.view.all',
    TASK_CREATE: 'task.create',
    TASK_ASSIGN: 'task.assign',
    TASK_EDIT: 'task.edit',
    TASK_WORK: 'task.work',
    TASK_REVIEW: 'task.review',
    TASK_MANAGE: 'task.manage',
    TASK_REPORT_VIEW: 'task.report.view',
    TASK_CONFIG: 'task.config',
    // Additional Tasks (self-logged work)
    ADDITIONAL_TASK_VIEW_OWN: 'additional_task.view.own',
    ADDITIONAL_TASK_VIEW_ALL: 'additional_task.view.all',
    ADDITIONAL_TASK_CREATE: 'additional_task.create',
    ADDITIONAL_TASK_MANAGE: 'additional_task.manage',
    // Calendar
    CALENDAR_VIEW_OWN: 'calendar.view.own',
    CALENDAR_VIEW_TEAM: 'calendar.view.team',
    CALENDAR_VIEW_ALL: 'calendar.view.all',
    CALENDAR_CREATE: 'calendar.create',
    CALENDAR_EDIT: 'calendar.edit',
    CALENDAR_DELETE: 'calendar.delete',
    // Performance
    PERFORMANCE_VIEW_OWN: 'performance.view.own',
    PERFORMANCE_VIEW_TEAM: 'performance.view.team',
    PERFORMANCE_VIEW_ALL: 'performance.view.all',
    PERFORMANCE_REVIEW: 'performance.review',
    PERFORMANCE_GOALS_MANAGE: 'performance.goals.manage',
    // Staff documents
    STAFF_DOCUMENTS_VIEW: 'staff.documents.view',
    STAFF_DOCUMENTS_MANAGE: 'staff.documents.manage',
    // Finance · Vendors
    FINANCE_VENDORS_VIEW: 'finance.vendors.view',
    FINANCE_VENDORS_CREATE: 'finance.vendors.create',
    FINANCE_VENDORS_EDIT: 'finance.vendors.edit',
    FINANCE_VENDORS_DELETE: 'finance.vendors.delete',
    // Finance · Purchases (+ payments)
    FINANCE_PURCHASES_VIEW: 'finance.purchases.view',
    FINANCE_PURCHASES_CREATE: 'finance.purchases.create',
    FINANCE_PURCHASES_PAY: 'finance.purchases.pay',
    // Finance · Ledger
    FINANCE_LEDGER_VIEW: 'finance.ledger.view',
    // Finance · Master (categories, payment modes, system rules, budget, audit logs)
    FINANCE_MASTER: 'finance.master',
    // Finance · Reimbursements
    FINANCE_REIMBURSEMENTS_MANAGE: 'finance.reimbursements.manage', // admin: accounts, credits, all ledger
    FINANCE_REIMBURSEMENT_REQUEST: 'finance.reimbursement.request', // employee: own wallet + add expense
    // Requirements
    REQUIREMENTS_VIEW: 'requirements.view',
    REQUIREMENTS_CREATE: 'requirements.create',
    REQUIREMENTS_EDIT: 'requirements.edit',
    REQUIREMENTS_DELETE: 'requirements.delete',
    REQUIREMENTS_APPROVE: 'requirements.approve',
    REQUIREMENTS_MASTER: 'requirements.master',
    REQUIREMENTS_OVERVIEW: 'requirements.overview',
    // Subscriptions
    SUBSCRIPTIONS_VIEW: 'subscriptions.view',
    SUBSCRIPTIONS_CREATE: 'subscriptions.create',
    SUBSCRIPTIONS_EDIT: 'subscriptions.edit',
    SUBSCRIPTIONS_DELETE: 'subscriptions.delete',
    SUBSCRIPTIONS_RENEW: 'subscriptions.renew',
    SUBSCRIPTIONS_CANCEL: 'subscriptions.cancel',
    SUBSCRIPTIONS_EXPORT: 'subscriptions.export',
    SUBSCRIPTIONS_OVERVIEW: 'subscriptions.overview',
    SUBSCRIPTIONS_MASTER: 'subscriptions.master',
    // Tech Support
    TECH_SUPPORT_VIEW_OWN: 'tech_support.view.own',
    TECH_SUPPORT_VIEW_ALL: 'tech_support.view.all',
    TECH_SUPPORT_CREATE: 'tech_support.create',
    TECH_SUPPORT_UPDATE: 'tech_support.update',
    TECH_SUPPORT_DELETE: 'tech_support.delete',
    TECH_SUPPORT_ASSIGN: 'tech_support.assign',
    TECH_SUPPORT_ESCALATE: 'tech_support.escalate',
    TECH_SUPPORT_CLOSE: 'tech_support.close',
    TECH_SUPPORT_MANAGE_CATEGORIES: 'tech_support.manage_categories',
    TECH_SUPPORT_MANAGE_SLA: 'tech_support.manage_sla',
    TECH_SUPPORT_VIEW_REPORTS: 'tech_support.view_reports',
    // Goals
    GOALS_VIEW_OWN: 'goals.view.own',
    GOALS_VIEW_TEAM: 'goals.view.team',
    GOALS_VIEW_ALL: 'goals.view.all',
    GOALS_CREATE: 'goals.create',
    GOALS_ASSIGN: 'goals.assign',
    GOALS_EDIT: 'goals.edit',
    GOALS_DELETE: 'goals.delete',
    GOALS_PROGRESS_UPDATE: 'goals.progress.update',
    GOALS_REVIEW: 'goals.review',
    GOALS_CONFIG: 'goals.config',
    // Reports & Analytics
    REPORTS_VIEW: 'reports.view',
    REPORTS_EXPORT: 'reports.export',
    REPORTS_GOALS_VIEW: 'reports.goals.view',
    // Delete Access Config (leave + penalty delete icon visibility)
    DELETE_ACCESS_MANAGE: 'delete_access.manage',
};
export const ALL_PERMISSION_CODES = Object.values(PERMISSIONS);
export const PERMISSION_MODULE = {
    [PERMISSIONS.STAFF_VIEW_ALL]: 'staff',
    [PERMISSIONS.STAFF_VIEW_TEAM]: 'staff',
    [PERMISSIONS.STAFF_CREATE]: 'staff',
    [PERMISSIONS.STAFF_EDIT]: 'staff',
    [PERMISSIONS.STAFF_DELETE]: 'staff',
    // 'hrms_staff' (the real module code), not the legacy 'staff' string above —
    // this must stay identical to the `module` value seeded in the migration.
    [PERMISSIONS.STAFF_EXPORT]: 'hrms_staff',
    [PERMISSIONS.ROLES_ASSIGN]: 'roles',
    [PERMISSIONS.ROLES_MANAGE]: 'roles',
    [PERMISSIONS.MODULES_ASSIGN]: 'staff',
    [PERMISSIONS.PROFILE_VIEW_OWN]: 'profile',
    [PERMISSIONS.PROFILE_EDIT_OWN]: 'profile',
    [PERMISSIONS.DEPARTMENTS_VIEW]: 'departments',
    [PERMISSIONS.DEPARTMENTS_CREATE]: 'departments',
    [PERMISSIONS.DEPARTMENTS_EDIT]: 'departments',
    [PERMISSIONS.DEPARTMENTS_DELETE]: 'departments',
    [PERMISSIONS.DESIGNATIONS_VIEW]: 'designations',
    [PERMISSIONS.DESIGNATIONS_CREATE]: 'designations',
    [PERMISSIONS.DESIGNATIONS_EDIT]: 'designations',
    [PERMISSIONS.DESIGNATIONS_DELETE]: 'designations',
    [PERMISSIONS.ATTENDANCE_VIEW_OWN]: 'attendance',
    [PERMISSIONS.ATTENDANCE_VIEW_TEAM]: 'attendance',
    [PERMISSIONS.ATTENDANCE_VIEW_ALL]: 'attendance',
    [PERMISSIONS.ATTENDANCE_PUNCH]: 'attendance',
    [PERMISSIONS.ATTENDANCE_REGULARIZE]: 'attendance',
    [PERMISSIONS.ATTENDANCE_MANAGE]: 'attendance',
    [PERMISSIONS.WATI_CONFIG_VIEW]: 'attendance',
    [PERMISSIONS.WATI_CONFIG_EDIT]: 'attendance',
    // Must equal the `module` seeded by migration 224.
    [PERMISSIONS.FACE_SCAN_KEYSTORES_VIEW]: 'hrms_attendance',
    [PERMISSIONS.FACE_SCAN_KEYSTORES_MANAGE]: 'hrms_attendance',
    // Must equal the `module` seeded by migration 226.
    [PERMISSIONS.TRACKING_VIEW]: 'hrms_tracking',
    [PERMISSIONS.TRACKING_MANAGE]: 'hrms_tracking',
    [PERMISSIONS.LEAVE_VIEW_OWN]: 'leave',
    [PERMISSIONS.LEAVE_VIEW_TEAM]: 'leave',
    [PERMISSIONS.LEAVE_VIEW_ALL]: 'leave',
    [PERMISSIONS.LEAVE_REQUEST]: 'leave',
    [PERMISSIONS.LEAVE_APPROVE]: 'leave',
    [PERMISSIONS.LEAVE_MANAGE]: 'leave',
    [PERMISSIONS.LEAVE_CANCEL]: 'leave',
    [PERMISSIONS.LEAVE_ADMIN]: 'leave',
    [PERMISSIONS.LEAVE_CREDIT_VIEW]: 'leave',
    [PERMISSIONS.SALARY_VIEW_OWN]: 'account_salary',
    [PERMISSIONS.SALARY_VIEW_ALL]: 'hrms_payroll',
    [PERMISSIONS.SALARY_MANAGE]: 'hrms_payroll',
    [PERMISSIONS.SALARY_PROCESS]: 'hrms_payroll',
    [PERMISSIONS.LOAN_VIEW_OWN]: 'account_loans',
    [PERMISSIONS.LOAN_MANAGE]: 'hrms_payroll',
    [PERMISSIONS.PENALTY_VIEW_OWN]: 'account_attendance',
    [PERMISSIONS.PENALTY_VIEW_ALL]: 'hrms_penalty',
    [PERMISSIONS.PENALTY_MANAGE]: 'hrms_penalty',
    [PERMISSIONS.PAID_HOURS_VIEW_OWN]: 'account_salary',
    [PERMISSIONS.PAID_HOURS_VIEW_ALL]: 'hrms_attendance',
    [PERMISSIONS.PAID_HOURS_MANAGE]: 'hrms_attendance',
    [PERMISSIONS.ORG_VIEW]: 'hrms_organization',
    [PERMISSIONS.ORG_MANAGE]: 'hrms_organization',
    [PERMISSIONS.RECRUITMENT_VIEW]: 'hrms_recruitment',
    [PERMISSIONS.RECRUITMENT_MANAGE]: 'hrms_recruitment',
    [PERMISSIONS.RECRUITMENT_CONFIG]: 'hrms_recruitment',
    [PERMISSIONS.NOTICE_VIEW]: 'notice',
    [PERMISSIONS.NOTICE_ACKNOWLEDGE]: 'notice',
    [PERMISSIONS.NOTICE_MANAGE]: 'hrms_notice',
    [PERMISSIONS.SOP_VIEW]: 'sop',
    [PERMISSIONS.SOP_ACKNOWLEDGE]: 'sop',
    [PERMISSIONS.SOP_MANAGE]: 'hrms_sop',
    [PERMISSIONS.SOP_ASSIGN]: 'hrms_sop',
    [PERMISSIONS.SOP_COMPLIANCE_VIEW]: 'hrms_sop',
    [PERMISSIONS.SOP_CONFIG]: 'hrms_sop',
    [PERMISSIONS.ASSETS_VIEW]: 'assets_list',
    [PERMISSIONS.ASSETS_CREATE]: 'assets_list',
    [PERMISSIONS.ASSETS_EDIT]: 'assets_list',
    [PERMISSIONS.ASSETS_DELETE]: 'assets_list',
    [PERMISSIONS.ASSETS_ASSIGN]: 'assets_list',
    [PERMISSIONS.ASSETS_EXPORT]: 'assets_list',
    [PERMISSIONS.ASSETS_OVERVIEW]: 'assets_overview',
    [PERMISSIONS.ASSETS_MASTER]: 'assets_master',
    [PERMISSIONS.ASSETS_VIEW_OWN]: 'account_assets',
    [PERMISSIONS.ID_CATEGORIES_MANAGE]: 'assets_master',
    [PERMISSIONS.ID_MANAGEMENT_VIEW]: 'assets_id_management',
    [PERMISSIONS.ID_MANAGEMENT_MANAGE]: 'assets_id_management',
    [PERMISSIONS.MY_IDS_VIEW_OWN]: 'account_my_ids',
    [PERMISSIONS.TASK_VIEW_OWN]: 'task',
    [PERMISSIONS.TASK_VIEW_TEAM]: 'task',
    [PERMISSIONS.TASK_VIEW_ALL]: 'task',
    [PERMISSIONS.TASK_CREATE]: 'task',
    [PERMISSIONS.TASK_ASSIGN]: 'task',
    [PERMISSIONS.TASK_EDIT]: 'task',
    [PERMISSIONS.TASK_WORK]: 'task',
    [PERMISSIONS.TASK_REVIEW]: 'task',
    [PERMISSIONS.TASK_MANAGE]: 'task',
    [PERMISSIONS.TASK_REPORT_VIEW]: 'task',
    [PERMISSIONS.TASK_CONFIG]: 'task',
    [PERMISSIONS.ADDITIONAL_TASK_VIEW_OWN]: 'additional_task',
    [PERMISSIONS.ADDITIONAL_TASK_VIEW_ALL]: 'additional_task',
    [PERMISSIONS.ADDITIONAL_TASK_CREATE]: 'additional_task',
    [PERMISSIONS.ADDITIONAL_TASK_MANAGE]: 'additional_task',
    [PERMISSIONS.CALENDAR_VIEW_OWN]: 'calendar',
    [PERMISSIONS.CALENDAR_VIEW_TEAM]: 'calendar',
    [PERMISSIONS.CALENDAR_VIEW_ALL]: 'calendar',
    [PERMISSIONS.CALENDAR_CREATE]: 'calendar',
    [PERMISSIONS.CALENDAR_EDIT]: 'calendar',
    [PERMISSIONS.CALENDAR_DELETE]: 'calendar',
    [PERMISSIONS.PERFORMANCE_VIEW_OWN]: 'hrms_staff',
    [PERMISSIONS.PERFORMANCE_VIEW_TEAM]: 'hrms_staff',
    [PERMISSIONS.PERFORMANCE_VIEW_ALL]: 'hrms_staff',
    [PERMISSIONS.PERFORMANCE_REVIEW]: 'hrms_staff',
    [PERMISSIONS.PERFORMANCE_GOALS_MANAGE]: 'hrms_staff',
    [PERMISSIONS.STAFF_DOCUMENTS_VIEW]: 'hrms_staff',
    [PERMISSIONS.STAFF_DOCUMENTS_MANAGE]: 'hrms_staff',
    [PERMISSIONS.FINANCE_VENDORS_VIEW]: 'finance_vendors',
    [PERMISSIONS.FINANCE_VENDORS_CREATE]: 'finance_vendors',
    [PERMISSIONS.FINANCE_VENDORS_EDIT]: 'finance_vendors',
    [PERMISSIONS.FINANCE_VENDORS_DELETE]: 'finance_vendors',
    [PERMISSIONS.FINANCE_PURCHASES_VIEW]: 'finance_purchases',
    [PERMISSIONS.FINANCE_PURCHASES_CREATE]: 'finance_purchases',
    [PERMISSIONS.FINANCE_PURCHASES_PAY]: 'finance_purchases',
    [PERMISSIONS.FINANCE_LEDGER_VIEW]: 'finance_ledger',
    [PERMISSIONS.FINANCE_MASTER]: 'finance_master',
    [PERMISSIONS.FINANCE_REIMBURSEMENTS_MANAGE]: 'finance_reimbursements',
    [PERMISSIONS.FINANCE_REIMBURSEMENT_REQUEST]: 'finance_reimbursement_self',
    [PERMISSIONS.REQUIREMENTS_VIEW]: 'requirements_list',
    [PERMISSIONS.REQUIREMENTS_CREATE]: 'requirements_list',
    [PERMISSIONS.REQUIREMENTS_EDIT]: 'requirements_list',
    [PERMISSIONS.REQUIREMENTS_DELETE]: 'requirements_list',
    [PERMISSIONS.REQUIREMENTS_APPROVE]: 'requirements_list',
    [PERMISSIONS.REQUIREMENTS_MASTER]: 'requirements_master',
    [PERMISSIONS.REQUIREMENTS_OVERVIEW]: 'requirements_overview',
    [PERMISSIONS.SUBSCRIPTIONS_VIEW]: 'subscription_list',
    [PERMISSIONS.SUBSCRIPTIONS_CREATE]: 'subscription_list',
    [PERMISSIONS.SUBSCRIPTIONS_EDIT]: 'subscription_list',
    [PERMISSIONS.SUBSCRIPTIONS_DELETE]: 'subscription_list',
    [PERMISSIONS.SUBSCRIPTIONS_RENEW]: 'subscription_list',
    [PERMISSIONS.SUBSCRIPTIONS_CANCEL]: 'subscription_list',
    [PERMISSIONS.SUBSCRIPTIONS_EXPORT]: 'subscription_list',
    [PERMISSIONS.SUBSCRIPTIONS_OVERVIEW]: 'subscription_overview',
    [PERMISSIONS.SUBSCRIPTIONS_MASTER]: 'subscription_master',
    [PERMISSIONS.TECH_SUPPORT_VIEW_OWN]: 'tech_support',
    [PERMISSIONS.TECH_SUPPORT_VIEW_ALL]: 'tech_support',
    [PERMISSIONS.TECH_SUPPORT_CREATE]: 'tech_support',
    [PERMISSIONS.TECH_SUPPORT_UPDATE]: 'tech_support',
    [PERMISSIONS.TECH_SUPPORT_DELETE]: 'tech_support',
    [PERMISSIONS.TECH_SUPPORT_ASSIGN]: 'tech_support',
    [PERMISSIONS.TECH_SUPPORT_ESCALATE]: 'tech_support',
    [PERMISSIONS.TECH_SUPPORT_CLOSE]: 'tech_support',
    [PERMISSIONS.TECH_SUPPORT_MANAGE_CATEGORIES]: 'tech_support',
    [PERMISSIONS.TECH_SUPPORT_MANAGE_SLA]: 'tech_support',
    [PERMISSIONS.TECH_SUPPORT_VIEW_REPORTS]: 'tech_support',
    [PERMISSIONS.GOALS_VIEW_OWN]: 'goals',
    [PERMISSIONS.GOALS_VIEW_TEAM]: 'goals',
    [PERMISSIONS.GOALS_VIEW_ALL]: 'goals',
    [PERMISSIONS.GOALS_CREATE]: 'goals',
    [PERMISSIONS.GOALS_ASSIGN]: 'goals',
    [PERMISSIONS.GOALS_EDIT]: 'goals',
    [PERMISSIONS.GOALS_DELETE]: 'goals',
    [PERMISSIONS.GOALS_PROGRESS_UPDATE]: 'goals',
    [PERMISSIONS.GOALS_REVIEW]: 'goals',
    [PERMISSIONS.GOALS_CONFIG]: 'goals',
    [PERMISSIONS.REPORTS_VIEW]: 'reports_overview',
    [PERMISSIONS.REPORTS_EXPORT]: 'reports_overview',
    [PERMISSIONS.REPORTS_GOALS_VIEW]: 'reports_overview',
    [PERMISSIONS.DELETE_ACCESS_MANAGE]: 'hrms_organization',
};
/**
 * Maps each permission to the module it lives inside. Used by the backend
 * `requirePermission` plugin to enforce the dual check: user must have the
 * permission AND own the module that permission belongs to.
 */
export const PERMISSION_MODULE_CODE = {
    [PERMISSIONS.STAFF_VIEW_ALL]: MODULES.HRMS_STAFF,
    [PERMISSIONS.STAFF_VIEW_TEAM]: MODULES.HRMS_STAFF,
    [PERMISSIONS.STAFF_CREATE]: MODULES.HRMS_STAFF,
    [PERMISSIONS.STAFF_EDIT]: MODULES.HRMS_STAFF,
    [PERMISSIONS.STAFF_DELETE]: MODULES.HRMS_STAFF,
    [PERMISSIONS.STAFF_EXPORT]: MODULES.HRMS_STAFF,
    [PERMISSIONS.ROLES_ASSIGN]: MODULES.HRMS_STAFF,
    [PERMISSIONS.ROLES_MANAGE]: MODULES.MASTER_ROLES,
    [PERMISSIONS.MODULES_ASSIGN]: MODULES.HRMS_STAFF,
    [PERMISSIONS.PROFILE_VIEW_OWN]: MODULES.PROFILE,
    [PERMISSIONS.PROFILE_EDIT_OWN]: MODULES.PROFILE,
    [PERMISSIONS.DEPARTMENTS_VIEW]: MODULES.MASTER_DEPARTMENTS,
    [PERMISSIONS.DEPARTMENTS_CREATE]: MODULES.MASTER_DEPARTMENTS,
    [PERMISSIONS.DEPARTMENTS_EDIT]: MODULES.MASTER_DEPARTMENTS,
    [PERMISSIONS.DEPARTMENTS_DELETE]: MODULES.MASTER_DEPARTMENTS,
    [PERMISSIONS.DESIGNATIONS_VIEW]: MODULES.MASTER_DESIGNATIONS,
    [PERMISSIONS.DESIGNATIONS_CREATE]: MODULES.MASTER_DESIGNATIONS,
    [PERMISSIONS.DESIGNATIONS_EDIT]: MODULES.MASTER_DESIGNATIONS,
    [PERMISSIONS.DESIGNATIONS_DELETE]: MODULES.MASTER_DESIGNATIONS,
    [PERMISSIONS.ATTENDANCE_VIEW_OWN]: MODULES.ACCOUNT_ATTENDANCE,
    [PERMISSIONS.ATTENDANCE_VIEW_TEAM]: MODULES.HRMS_ATTENDANCE,
    [PERMISSIONS.ATTENDANCE_VIEW_ALL]: MODULES.HRMS_ATTENDANCE,
    [PERMISSIONS.ATTENDANCE_REGULARIZE]: MODULES.HRMS_ATTENDANCE,
    [PERMISSIONS.ATTENDANCE_MANAGE]: MODULES.HRMS_ATTENDANCE,
    [PERMISSIONS.WATI_CONFIG_VIEW]: MODULES.HRMS_ATTENDANCE,
    [PERMISSIONS.WATI_CONFIG_EDIT]: MODULES.HRMS_ATTENDANCE,
    [PERMISSIONS.FACE_SCAN_KEYSTORES_VIEW]: MODULES.HRMS_ATTENDANCE,
    [PERMISSIONS.FACE_SCAN_KEYSTORES_MANAGE]: MODULES.HRMS_ATTENDANCE,
    [PERMISSIONS.TRACKING_VIEW]: MODULES.HRMS_TRACKING,
    [PERMISSIONS.TRACKING_MANAGE]: MODULES.HRMS_TRACKING,
    [PERMISSIONS.LEAVE_VIEW_OWN]: MODULES.LEAVE,
    [PERMISSIONS.LEAVE_VIEW_TEAM]: MODULES.HRMS_LEAVE,
    [PERMISSIONS.LEAVE_VIEW_ALL]: MODULES.HRMS_LEAVE,
    [PERMISSIONS.LEAVE_REQUEST]: MODULES.LEAVE,
    [PERMISSIONS.LEAVE_APPROVE]: MODULES.HRMS_LEAVE,
    [PERMISSIONS.LEAVE_MANAGE]: MODULES.HRMS_LEAVE,
    [PERMISSIONS.LEAVE_CANCEL]: MODULES.LEAVE,
    [PERMISSIONS.LEAVE_ADMIN]: MODULES.HRMS_LEAVE,
    [PERMISSIONS.LEAVE_CREDIT_VIEW]: MODULES.LEAVE,
    [PERMISSIONS.SALARY_VIEW_OWN]: MODULES.ACCOUNT_SALARY,
    [PERMISSIONS.SALARY_VIEW_ALL]: MODULES.HRMS_PAYROLL,
    [PERMISSIONS.SALARY_MANAGE]: MODULES.HRMS_PAYROLL,
    [PERMISSIONS.SALARY_PROCESS]: MODULES.HRMS_PAYROLL,
    [PERMISSIONS.LOAN_VIEW_OWN]: MODULES.ACCOUNT_LOANS,
    [PERMISSIONS.LOAN_MANAGE]: MODULES.HRMS_PAYROLL,
    [PERMISSIONS.PENALTY_VIEW_OWN]: MODULES.ACCOUNT_ATTENDANCE,
    [PERMISSIONS.PENALTY_VIEW_ALL]: MODULES.HRMS_PENALTY,
    [PERMISSIONS.PENALTY_MANAGE]: MODULES.HRMS_PENALTY,
    [PERMISSIONS.PAID_HOURS_VIEW_OWN]: MODULES.ACCOUNT_SALARY,
    [PERMISSIONS.PAID_HOURS_VIEW_ALL]: MODULES.HRMS_ATTENDANCE,
    [PERMISSIONS.PAID_HOURS_MANAGE]: MODULES.HRMS_ATTENDANCE,
    [PERMISSIONS.ORG_VIEW]: MODULES.HRMS_ORGANIZATION,
    [PERMISSIONS.ORG_MANAGE]: MODULES.HRMS_ORGANIZATION,
    [PERMISSIONS.RECRUITMENT_VIEW]: MODULES.HRMS_RECRUITMENT,
    [PERMISSIONS.RECRUITMENT_MANAGE]: MODULES.HRMS_RECRUITMENT,
    [PERMISSIONS.RECRUITMENT_CONFIG]: MODULES.HRMS_RECRUITMENT,
    [PERMISSIONS.NOTICE_VIEW]: MODULES.NOTICE,
    [PERMISSIONS.NOTICE_ACKNOWLEDGE]: MODULES.NOTICE,
    [PERMISSIONS.NOTICE_MANAGE]: MODULES.HRMS_NOTICE,
    [PERMISSIONS.SOP_VIEW]: MODULES.SOP,
    [PERMISSIONS.SOP_ACKNOWLEDGE]: MODULES.SOP,
    [PERMISSIONS.SOP_MANAGE]: MODULES.HRMS_SOP,
    [PERMISSIONS.SOP_ASSIGN]: MODULES.HRMS_SOP,
    [PERMISSIONS.SOP_COMPLIANCE_VIEW]: MODULES.HRMS_SOP,
    [PERMISSIONS.SOP_CONFIG]: MODULES.HRMS_SOP,
    [PERMISSIONS.ASSETS_VIEW]: MODULES.ASSETS_LIST,
    [PERMISSIONS.ASSETS_CREATE]: MODULES.ASSETS_LIST,
    [PERMISSIONS.ASSETS_EDIT]: MODULES.ASSETS_LIST,
    [PERMISSIONS.ASSETS_DELETE]: MODULES.ASSETS_LIST,
    [PERMISSIONS.ASSETS_ASSIGN]: MODULES.ASSETS_LIST,
    [PERMISSIONS.ASSETS_EXPORT]: MODULES.ASSETS_LIST,
    [PERMISSIONS.ASSETS_OVERVIEW]: MODULES.ASSETS_OVERVIEW,
    [PERMISSIONS.ASSETS_MASTER]: MODULES.ASSETS_MASTER,
    [PERMISSIONS.ASSETS_VIEW_OWN]: MODULES.ACCOUNT_ASSETS,
    [PERMISSIONS.ID_CATEGORIES_MANAGE]: MODULES.ASSETS_MASTER,
    [PERMISSIONS.ID_MANAGEMENT_VIEW]: MODULES.ASSETS_ID_MANAGEMENT,
    [PERMISSIONS.ID_MANAGEMENT_MANAGE]: MODULES.ASSETS_ID_MANAGEMENT,
    [PERMISSIONS.MY_IDS_VIEW_OWN]: MODULES.ACCOUNT_MY_IDS,
    [PERMISSIONS.TASK_VIEW_OWN]: MODULES.TASK,
    [PERMISSIONS.TASK_VIEW_TEAM]: MODULES.TASK,
    [PERMISSIONS.TASK_VIEW_ALL]: MODULES.TASK,
    [PERMISSIONS.TASK_CREATE]: MODULES.TASK,
    [PERMISSIONS.TASK_ASSIGN]: MODULES.TASK,
    [PERMISSIONS.TASK_EDIT]: MODULES.TASK,
    [PERMISSIONS.TASK_WORK]: MODULES.TASK,
    [PERMISSIONS.TASK_REVIEW]: MODULES.TASK,
    [PERMISSIONS.TASK_MANAGE]: MODULES.TASK,
    [PERMISSIONS.TASK_REPORT_VIEW]: MODULES.TASK,
    [PERMISSIONS.TASK_CONFIG]: MODULES.TASK,
    [PERMISSIONS.ADDITIONAL_TASK_VIEW_OWN]: MODULES.ADDITIONAL_TASK,
    [PERMISSIONS.ADDITIONAL_TASK_VIEW_ALL]: MODULES.ADDITIONAL_TASK,
    [PERMISSIONS.ADDITIONAL_TASK_CREATE]: MODULES.ADDITIONAL_TASK,
    [PERMISSIONS.ADDITIONAL_TASK_MANAGE]: MODULES.ADDITIONAL_TASK,
    [PERMISSIONS.CALENDAR_VIEW_OWN]: MODULES.CALENDAR,
    [PERMISSIONS.CALENDAR_VIEW_TEAM]: MODULES.CALENDAR,
    [PERMISSIONS.CALENDAR_VIEW_ALL]: MODULES.CALENDAR,
    [PERMISSIONS.CALENDAR_CREATE]: MODULES.CALENDAR,
    [PERMISSIONS.CALENDAR_EDIT]: MODULES.CALENDAR,
    [PERMISSIONS.CALENDAR_DELETE]: MODULES.CALENDAR,
    [PERMISSIONS.PERFORMANCE_VIEW_OWN]: MODULES.HRMS_STAFF,
    [PERMISSIONS.PERFORMANCE_VIEW_TEAM]: MODULES.HRMS_STAFF,
    [PERMISSIONS.PERFORMANCE_VIEW_ALL]: MODULES.HRMS_STAFF,
    [PERMISSIONS.PERFORMANCE_REVIEW]: MODULES.HRMS_STAFF,
    [PERMISSIONS.PERFORMANCE_GOALS_MANAGE]: MODULES.HRMS_STAFF,
    [PERMISSIONS.STAFF_DOCUMENTS_VIEW]: MODULES.HRMS_STAFF,
    [PERMISSIONS.STAFF_DOCUMENTS_MANAGE]: MODULES.HRMS_STAFF,
    [PERMISSIONS.FINANCE_VENDORS_VIEW]: MODULES.FINANCE_VENDORS,
    [PERMISSIONS.FINANCE_VENDORS_CREATE]: MODULES.FINANCE_VENDORS,
    [PERMISSIONS.FINANCE_VENDORS_EDIT]: MODULES.FINANCE_VENDORS,
    [PERMISSIONS.FINANCE_VENDORS_DELETE]: MODULES.FINANCE_VENDORS,
    [PERMISSIONS.FINANCE_PURCHASES_VIEW]: MODULES.FINANCE_PURCHASES,
    [PERMISSIONS.FINANCE_PURCHASES_CREATE]: MODULES.FINANCE_PURCHASES,
    [PERMISSIONS.FINANCE_PURCHASES_PAY]: MODULES.FINANCE_PURCHASES,
    [PERMISSIONS.FINANCE_LEDGER_VIEW]: MODULES.FINANCE_LEDGER,
    [PERMISSIONS.FINANCE_MASTER]: MODULES.FINANCE_MASTER,
    [PERMISSIONS.FINANCE_REIMBURSEMENTS_MANAGE]: MODULES.FINANCE_REIMBURSEMENTS,
    [PERMISSIONS.FINANCE_REIMBURSEMENT_REQUEST]: MODULES.FINANCE_REIMBURSEMENT_SELF,
    [PERMISSIONS.REQUIREMENTS_VIEW]: MODULES.REQUIREMENTS_LIST,
    [PERMISSIONS.REQUIREMENTS_CREATE]: MODULES.REQUIREMENTS_LIST,
    [PERMISSIONS.REQUIREMENTS_EDIT]: MODULES.REQUIREMENTS_LIST,
    [PERMISSIONS.REQUIREMENTS_DELETE]: MODULES.REQUIREMENTS_LIST,
    [PERMISSIONS.REQUIREMENTS_APPROVE]: MODULES.REQUIREMENTS_LIST,
    [PERMISSIONS.REQUIREMENTS_MASTER]: MODULES.REQUIREMENTS_MASTER,
    [PERMISSIONS.REQUIREMENTS_OVERVIEW]: MODULES.REQUIREMENTS_OVERVIEW,
    [PERMISSIONS.SUBSCRIPTIONS_VIEW]: MODULES.SUBSCRIPTION_LIST,
    [PERMISSIONS.SUBSCRIPTIONS_CREATE]: MODULES.SUBSCRIPTION_LIST,
    [PERMISSIONS.SUBSCRIPTIONS_EDIT]: MODULES.SUBSCRIPTION_LIST,
    [PERMISSIONS.SUBSCRIPTIONS_DELETE]: MODULES.SUBSCRIPTION_LIST,
    [PERMISSIONS.SUBSCRIPTIONS_RENEW]: MODULES.SUBSCRIPTION_LIST,
    [PERMISSIONS.SUBSCRIPTIONS_CANCEL]: MODULES.SUBSCRIPTION_LIST,
    [PERMISSIONS.SUBSCRIPTIONS_EXPORT]: MODULES.SUBSCRIPTION_LIST,
    [PERMISSIONS.SUBSCRIPTIONS_OVERVIEW]: MODULES.SUBSCRIPTION_OVERVIEW,
    [PERMISSIONS.SUBSCRIPTIONS_MASTER]: MODULES.SUBSCRIPTION_MASTER,
    [PERMISSIONS.TECH_SUPPORT_VIEW_OWN]: MODULES.TECH_SUPPORT,
    [PERMISSIONS.TECH_SUPPORT_VIEW_ALL]: MODULES.TECH_SUPPORT,
    [PERMISSIONS.TECH_SUPPORT_CREATE]: MODULES.TECH_SUPPORT,
    [PERMISSIONS.TECH_SUPPORT_UPDATE]: MODULES.TECH_SUPPORT,
    [PERMISSIONS.TECH_SUPPORT_DELETE]: MODULES.TECH_SUPPORT,
    [PERMISSIONS.TECH_SUPPORT_ASSIGN]: MODULES.TECH_SUPPORT,
    [PERMISSIONS.TECH_SUPPORT_ESCALATE]: MODULES.TECH_SUPPORT,
    [PERMISSIONS.TECH_SUPPORT_CLOSE]: MODULES.TECH_SUPPORT,
    [PERMISSIONS.TECH_SUPPORT_MANAGE_CATEGORIES]: MODULES.TECH_SUPPORT,
    [PERMISSIONS.TECH_SUPPORT_MANAGE_SLA]: MODULES.TECH_SUPPORT,
    [PERMISSIONS.TECH_SUPPORT_VIEW_REPORTS]: MODULES.TECH_SUPPORT,
    [PERMISSIONS.GOALS_VIEW_OWN]: MODULES.GOALS,
    [PERMISSIONS.GOALS_VIEW_TEAM]: MODULES.GOALS,
    [PERMISSIONS.GOALS_VIEW_ALL]: MODULES.GOALS,
    [PERMISSIONS.GOALS_CREATE]: MODULES.GOALS,
    [PERMISSIONS.GOALS_ASSIGN]: MODULES.GOALS,
    [PERMISSIONS.GOALS_EDIT]: MODULES.GOALS,
    [PERMISSIONS.GOALS_DELETE]: MODULES.GOALS,
    [PERMISSIONS.GOALS_PROGRESS_UPDATE]: MODULES.GOALS,
    [PERMISSIONS.GOALS_REVIEW]: MODULES.GOALS,
    [PERMISSIONS.GOALS_CONFIG]: MODULES.GOALS,
    [PERMISSIONS.REPORTS_VIEW]: MODULES.REPORTS_OVERVIEW,
    [PERMISSIONS.REPORTS_EXPORT]: MODULES.REPORTS_OVERVIEW,
    [PERMISSIONS.REPORTS_GOALS_VIEW]: MODULES.REPORTS_OVERVIEW,
    [PERMISSIONS.DELETE_ACCESS_MANAGE]: MODULES.HRMS_ORGANIZATION,
};
export const PERMISSION_DESCRIPTION = {
    [PERMISSIONS.STAFF_VIEW_ALL]: 'View all staff in the organization',
    [PERMISSIONS.STAFF_VIEW_TEAM]: 'View staff in own team / direct reports',
    [PERMISSIONS.STAFF_CREATE]: 'Create new staff accounts',
    [PERMISSIONS.STAFF_EDIT]: 'Edit existing staff records',
    [PERMISSIONS.STAFF_DELETE]: 'Soft-delete (deactivate) staff accounts',
    [PERMISSIONS.STAFF_EXPORT]: 'Export the staff register to Excel',
    [PERMISSIONS.ROLES_ASSIGN]: 'Assign roles to staff',
    [PERMISSIONS.ROLES_MANAGE]: 'Manage role-permission and role default-module mappings',
    [PERMISSIONS.MODULES_ASSIGN]: 'Grant or revoke module visibility for a specific staff user',
    [PERMISSIONS.PROFILE_VIEW_OWN]: 'View own profile',
    [PERMISSIONS.PROFILE_EDIT_OWN]: 'Edit own profile',
    [PERMISSIONS.DEPARTMENTS_VIEW]: 'View departments',
    [PERMISSIONS.DEPARTMENTS_CREATE]: 'Create departments',
    [PERMISSIONS.DEPARTMENTS_EDIT]: 'Edit departments',
    [PERMISSIONS.DEPARTMENTS_DELETE]: 'Delete (soft) departments',
    [PERMISSIONS.DESIGNATIONS_VIEW]: 'View designations',
    [PERMISSIONS.DESIGNATIONS_CREATE]: 'Create designations',
    [PERMISSIONS.DESIGNATIONS_EDIT]: 'Edit designations',
    [PERMISSIONS.DESIGNATIONS_DELETE]: 'Delete (soft) designations',
    [PERMISSIONS.ATTENDANCE_VIEW_OWN]: 'View own attendance records',
    [PERMISSIONS.ATTENDANCE_VIEW_TEAM]: 'View team attendance records',
    [PERMISSIONS.ATTENDANCE_VIEW_ALL]: 'View all staff attendance',
    [PERMISSIONS.ATTENDANCE_PUNCH]: 'Record punch in/out',
    [PERMISSIONS.ATTENDANCE_REGULARIZE]: 'Regularize / correct attendance records',
    [PERMISSIONS.ATTENDANCE_MANAGE]: 'Manage attendance settings and reports',
    [PERMISSIONS.WATI_CONFIG_VIEW]: 'View the WATI miss-punch reminder configuration',
    [PERMISSIONS.WATI_CONFIG_EDIT]: 'Edit the WATI reminder config, send test messages',
    [PERMISSIONS.FACE_SCAN_KEYSTORES_VIEW]: 'View face-scan keystores held on the Rate API',
    [PERMISSIONS.FACE_SCAN_KEYSTORES_MANAGE]: 'Create, edit, switch off, test and delete face-scan keystores',
    [PERMISSIONS.TRACKING_VIEW]: 'View desktop tracker presence, capture stats and screenshots',
    [PERMISSIONS.TRACKING_MANAGE]: 'Rename, pause, set the interval of and remove tracked people; clean up deleted screenshots',
    [PERMISSIONS.LEAVE_VIEW_OWN]: 'View own leave requests and balances',
    [PERMISSIONS.LEAVE_VIEW_TEAM]: 'View team members leave requests',
    [PERMISSIONS.LEAVE_VIEW_ALL]: 'View all staff leave requests',
    [PERMISSIONS.LEAVE_REQUEST]: 'Submit leave requests',
    [PERMISSIONS.LEAVE_APPROVE]: 'Approve or reject leave requests from team',
    [PERMISSIONS.LEAVE_MANAGE]: 'Manage leave types, rules, and approval flows',
    [PERMISSIONS.LEAVE_CANCEL]: 'Cancel own pending leave requests',
    [PERMISSIONS.LEAVE_ADMIN]: 'Trigger monthly credit accrual and yearly balance reset',
    [PERMISSIONS.LEAVE_CREDIT_VIEW]: 'View own leave credit ledger history',
    [PERMISSIONS.SALARY_VIEW_OWN]: 'View own salary records and monthly history',
    [PERMISSIONS.SALARY_VIEW_ALL]: 'View all staff salary records',
    [PERMISSIONS.SALARY_MANAGE]: 'Manage employee financial data and payroll config',
    [PERMISSIONS.SALARY_PROCESS]: 'Access payroll processing',
    [PERMISSIONS.LOAN_VIEW_OWN]: 'View own loan and advance records',
    [PERMISSIONS.LOAN_MANAGE]: 'Create, edit, pay EMI, pause, and close loans and advances',
    [PERMISSIONS.PENALTY_VIEW_OWN]: 'View own penalties (self-service)',
    [PERMISSIONS.PENALTY_VIEW_ALL]: 'View all employee penalties',
    [PERMISSIONS.PENALTY_MANAGE]: 'Create, approve, and reject employee penalties',
    [PERMISSIONS.PAID_HOURS_VIEW_OWN]: 'View own company paid hours records',
    [PERMISSIONS.PAID_HOURS_VIEW_ALL]: 'View all company paid hours records',
    [PERMISSIONS.PAID_HOURS_MANAGE]: 'Create, approve, and reject company paid hours',
    [PERMISSIONS.ORG_VIEW]: 'View organization hierarchy',
    [PERMISSIONS.ORG_MANAGE]: 'Manage org nodes and designation assignments',
    [PERMISSIONS.RECRUITMENT_VIEW]: 'View candidates, recruitment pipeline, and onboarding/exit processes',
    [PERMISSIONS.RECRUITMENT_MANAGE]: 'Create and manage candidates, move stages, run onboarding/exit processes',
    [PERMISSIONS.RECRUITMENT_CONFIG]: 'Configure recruitment processes and onboarding/exit step templates',
    [PERMISSIONS.NOTICE_VIEW]: 'View notices published to me',
    [PERMISSIONS.NOTICE_ACKNOWLEDGE]: 'Acknowledge a notice that requires confirmation',
    [PERMISSIONS.NOTICE_MANAGE]: 'Create, edit, publish, archive, and track compliance for notices',
    [PERMISSIONS.SOP_VIEW]: 'View SOPs assigned or visible to me',
    [PERMISSIONS.SOP_ACKNOWLEDGE]: 'Acknowledge ("read & understood") an assigned SOP',
    [PERMISSIONS.SOP_MANAGE]: 'Create, edit, archive SOPs and upload SOP documents',
    [PERMISSIONS.SOP_ASSIGN]: 'Assign SOPs to users and departments',
    [PERMISSIONS.SOP_COMPLIANCE_VIEW]: 'View SOP compliance and acknowledgment tracking',
    [PERMISSIONS.SOP_CONFIG]: 'Manage SOP categories',
    [PERMISSIONS.ASSETS_VIEW]: 'View all assets in the organization',
    [PERMISSIONS.ASSETS_CREATE]: 'Create new asset records',
    [PERMISSIONS.ASSETS_EDIT]: 'Edit asset details, status, and documents',
    [PERMISSIONS.ASSETS_DELETE]: 'Soft-delete asset records',
    [PERMISSIONS.ASSETS_ASSIGN]: 'Assign or unassign assets to users and departments',
    [PERMISSIONS.ASSETS_EXPORT]: 'Export the asset register to CSV',
    [PERMISSIONS.ASSETS_OVERVIEW]: 'View asset overview dashboard and analytics',
    [PERMISSIONS.ASSETS_MASTER]: 'Manage asset categories, subcategories, brands, statuses, and settings',
    [PERMISSIONS.ASSETS_VIEW_OWN]: 'View own assigned assets (self-service)',
    [PERMISSIONS.ID_CATEGORIES_MANAGE]: 'Create, edit and delete ID categories such as Google or Microsoft',
    [PERMISSIONS.ID_MANAGEMENT_VIEW]: 'List saved account IDs for all users',
    [PERMISSIONS.ID_MANAGEMENT_MANAGE]: 'Add, edit and delete saved account IDs for any user',
    [PERMISSIONS.MY_IDS_VIEW_OWN]: 'View own saved account IDs (self-service)',
    [PERMISSIONS.TASK_VIEW_OWN]: 'View own assigned tasks',
    [PERMISSIONS.TASK_VIEW_TEAM]: 'View tasks of own team / direct reports',
    [PERMISSIONS.TASK_VIEW_ALL]: 'View all tasks across the organization',
    [PERMISSIONS.TASK_CREATE]: 'Create new tasks',
    [PERMISSIONS.TASK_ASSIGN]: 'Assign or unassign users on a task',
    [PERMISSIONS.TASK_EDIT]: 'Edit task details',
    [PERMISSIONS.TASK_WORK]: 'Accept, start, submit, or skip own task occurrences',
    [PERMISSIONS.TASK_REVIEW]: 'Approve or return submitted tasks for improvement',
    [PERMISSIONS.TASK_MANAGE]: 'Stop, reactivate and delete tasks',
    [PERMISSIONS.TASK_REPORT_VIEW]: 'View task report snapshots',
    [PERMISSIONS.TASK_CONFIG]: 'Configure task types, statuses, reset/reminder/report rules',
    [PERMISSIONS.ADDITIONAL_TASK_VIEW_OWN]: 'View own additional (self-logged) work',
    [PERMISSIONS.ADDITIONAL_TASK_VIEW_ALL]: 'View all staff additional work',
    [PERMISSIONS.ADDITIONAL_TASK_CREATE]: 'Log additional work',
    [PERMISSIONS.ADDITIONAL_TASK_MANAGE]: 'Edit or delete additional work records',
    [PERMISSIONS.CALENDAR_VIEW_OWN]: 'View own calendar events, tasks, leave, and attendance',
    [PERMISSIONS.CALENDAR_VIEW_TEAM]: 'View team members calendar events',
    [PERMISSIONS.CALENDAR_VIEW_ALL]: 'View all staff calendar data',
    [PERMISSIONS.CALENDAR_CREATE]: 'Create custom calendar events and reminders',
    [PERMISSIONS.CALENDAR_EDIT]: 'Edit own calendar events',
    [PERMISSIONS.CALENDAR_DELETE]: 'Delete own calendar events',
    [PERMISSIONS.PERFORMANCE_VIEW_OWN]: 'View own performance metrics, goals and reviews',
    [PERMISSIONS.PERFORMANCE_VIEW_TEAM]: 'View team members\' performance metrics',
    [PERMISSIONS.PERFORMANCE_VIEW_ALL]: 'View all staff performance data',
    [PERMISSIONS.PERFORMANCE_REVIEW]: 'Write and submit performance reviews for staff',
    [PERMISSIONS.PERFORMANCE_GOALS_MANAGE]: 'Create, edit, and delete performance goals for staff',
    [PERMISSIONS.STAFF_DOCUMENTS_VIEW]: 'View and download a staff member\'s documents',
    [PERMISSIONS.STAFF_DOCUMENTS_MANAGE]: 'Upload and delete a staff member\'s documents',
    [PERMISSIONS.FINANCE_VENDORS_VIEW]: 'View vendors and their financial profiles',
    [PERMISSIONS.FINANCE_VENDORS_CREATE]: 'Create new vendors',
    [PERMISSIONS.FINANCE_VENDORS_EDIT]: 'Edit vendor details and credit limits',
    [PERMISSIONS.FINANCE_VENDORS_DELETE]: 'Soft-delete (deactivate) vendors',
    [PERMISSIONS.FINANCE_PURCHASES_VIEW]: 'View purchases, invoices, and payment summary',
    [PERMISSIONS.FINANCE_PURCHASES_CREATE]: 'Create purchase entries with invoice upload',
    [PERMISSIONS.FINANCE_PURCHASES_PAY]: 'Record payments against purchases',
    [PERMISSIONS.FINANCE_LEDGER_VIEW]: 'View the vendor ledger and aging report',
    [PERMISSIONS.FINANCE_MASTER]: 'Manage purchase categories, payment modes, system rules, and view budget & audit logs',
    [PERMISSIONS.FINANCE_REIMBURSEMENTS_MANAGE]: 'Create reimbursement accounts, credit balances, and view all reimbursement ledgers',
    [PERMISSIONS.FINANCE_REIMBURSEMENT_REQUEST]: 'View own reimbursement wallet and submit expenses',
    [PERMISSIONS.REQUIREMENTS_VIEW]: 'View all requirements in the organization',
    [PERMISSIONS.REQUIREMENTS_CREATE]: 'Submit new resource requirements',
    [PERMISSIONS.REQUIREMENTS_EDIT]: 'Edit requirement details and notes',
    [PERMISSIONS.REQUIREMENTS_DELETE]: 'Soft-delete requirement records',
    [PERMISSIONS.REQUIREMENTS_APPROVE]: 'Approve or reject submitted requirements',
    [PERMISSIONS.REQUIREMENTS_MASTER]: 'Manage requirement categories, statuses, and settings',
    [PERMISSIONS.REQUIREMENTS_OVERVIEW]: 'View requirements overview dashboard and analytics',
    [PERMISSIONS.SUBSCRIPTIONS_VIEW]: 'View all subscriptions in the organization',
    [PERMISSIONS.SUBSCRIPTIONS_CREATE]: 'Create new subscription records',
    [PERMISSIONS.SUBSCRIPTIONS_EDIT]: 'Edit subscription details, status, and billing',
    [PERMISSIONS.SUBSCRIPTIONS_DELETE]: 'Soft-delete subscription records',
    [PERMISSIONS.SUBSCRIPTIONS_RENEW]: 'Manually renew a subscription and record history',
    [PERMISSIONS.SUBSCRIPTIONS_CANCEL]: 'Cancel an active subscription with reason',
    [PERMISSIONS.SUBSCRIPTIONS_EXPORT]: 'Export subscriptions list to CSV',
    [PERMISSIONS.SUBSCRIPTIONS_OVERVIEW]: 'View subscription overview dashboard and analytics',
    [PERMISSIONS.SUBSCRIPTIONS_MASTER]: 'Manage subscription categories, currencies, statuses, billing cycles, and audit logs',
    [PERMISSIONS.TECH_SUPPORT_VIEW_OWN]: 'View own submitted support tickets',
    [PERMISSIONS.TECH_SUPPORT_VIEW_ALL]: 'View all support tickets in the organization',
    [PERMISSIONS.TECH_SUPPORT_CREATE]: 'Submit a new support ticket',
    [PERMISSIONS.TECH_SUPPORT_UPDATE]: 'Edit support ticket details',
    [PERMISSIONS.TECH_SUPPORT_DELETE]: 'Soft-delete a support ticket',
    [PERMISSIONS.TECH_SUPPORT_ASSIGN]: 'Assign or reassign tickets to support staff',
    [PERMISSIONS.TECH_SUPPORT_ESCALATE]: 'Escalate a ticket to a higher support level',
    [PERMISSIONS.TECH_SUPPORT_CLOSE]: 'Close a resolved support ticket',
    [PERMISSIONS.TECH_SUPPORT_MANAGE_CATEGORIES]: 'Manage support ticket categories',
    [PERMISSIONS.TECH_SUPPORT_MANAGE_SLA]: 'Manage SLA policies for support tickets',
    [PERMISSIONS.TECH_SUPPORT_VIEW_REPORTS]: 'View support dashboard and analytics',
    [PERMISSIONS.GOALS_VIEW_OWN]: 'View own goals',
    [PERMISSIONS.GOALS_VIEW_TEAM]: 'View goals of employees in own department',
    [PERMISSIONS.GOALS_VIEW_ALL]: 'View goals of every employee',
    [PERMISSIONS.GOALS_CREATE]: 'Create a goal',
    [PERMISSIONS.GOALS_ASSIGN]: 'Assign a goal to another employee',
    [PERMISSIONS.GOALS_EDIT]: 'Edit goal details',
    [PERMISSIONS.GOALS_DELETE]: 'Delete a goal',
    [PERMISSIONS.GOALS_PROGRESS_UPDATE]: 'Log progress and change goal status',
    [PERMISSIONS.GOALS_REVIEW]: 'Review and approve submitted goals',
    [PERMISSIONS.GOALS_CONFIG]: 'Manage goal categories and automation',
    [PERMISSIONS.REPORTS_VIEW]: 'View reports and analytics overview across all modules',
    [PERMISSIONS.REPORTS_EXPORT]: 'Export reports data to CSV',
    [PERMISSIONS.REPORTS_GOALS_VIEW]: 'View the Goal Report tab in Reports Overview',
    [PERMISSIONS.DELETE_ACCESS_MANAGE]: 'Configure who can delete leave and penalty records',
};
export const ROLE_PERMISSION_SEED = {
    [ROLES.SUPER_ADMIN]: [...ALL_PERMISSION_CODES],
    [ROLES.ADMIN]: [
        PERMISSIONS.STAFF_VIEW_ALL,
        PERMISSIONS.STAFF_VIEW_TEAM,
        PERMISSIONS.STAFF_CREATE,
        PERMISSIONS.STAFF_EDIT,
        PERMISSIONS.STAFF_DELETE,
        PERMISSIONS.STAFF_EXPORT,
        PERMISSIONS.ROLES_ASSIGN,
        PERMISSIONS.MODULES_ASSIGN,
        PERMISSIONS.PROFILE_VIEW_OWN,
        PERMISSIONS.PROFILE_EDIT_OWN,
        PERMISSIONS.DEPARTMENTS_VIEW,
        PERMISSIONS.DEPARTMENTS_CREATE,
        PERMISSIONS.DEPARTMENTS_EDIT,
        PERMISSIONS.DEPARTMENTS_DELETE,
        PERMISSIONS.DESIGNATIONS_VIEW,
        PERMISSIONS.DESIGNATIONS_CREATE,
        PERMISSIONS.DESIGNATIONS_EDIT,
        PERMISSIONS.DESIGNATIONS_DELETE,
        PERMISSIONS.ATTENDANCE_VIEW_OWN,
        PERMISSIONS.ATTENDANCE_VIEW_TEAM,
        PERMISSIONS.ATTENDANCE_VIEW_ALL,
        PERMISSIONS.ATTENDANCE_PUNCH,
        PERMISSIONS.ATTENDANCE_REGULARIZE,
        PERMISSIONS.ATTENDANCE_MANAGE,
        PERMISSIONS.WATI_CONFIG_VIEW,
        PERMISSIONS.WATI_CONFIG_EDIT,
        PERMISSIONS.FACE_SCAN_KEYSTORES_VIEW,
        PERMISSIONS.FACE_SCAN_KEYSTORES_MANAGE,
        PERMISSIONS.TRACKING_VIEW,
        PERMISSIONS.TRACKING_MANAGE,
        PERMISSIONS.LEAVE_VIEW_OWN,
        PERMISSIONS.LEAVE_VIEW_TEAM,
        PERMISSIONS.LEAVE_VIEW_ALL,
        PERMISSIONS.LEAVE_REQUEST,
        PERMISSIONS.LEAVE_APPROVE,
        PERMISSIONS.LEAVE_MANAGE,
        PERMISSIONS.LEAVE_CANCEL,
        PERMISSIONS.LEAVE_ADMIN,
        PERMISSIONS.LEAVE_CREDIT_VIEW,
        PERMISSIONS.SALARY_VIEW_OWN,
        PERMISSIONS.SALARY_VIEW_ALL,
        PERMISSIONS.SALARY_MANAGE,
        PERMISSIONS.SALARY_PROCESS,
        PERMISSIONS.LOAN_VIEW_OWN,
        PERMISSIONS.LOAN_MANAGE,
        PERMISSIONS.PENALTY_VIEW_OWN,
        PERMISSIONS.PENALTY_VIEW_ALL,
        PERMISSIONS.PENALTY_MANAGE,
        PERMISSIONS.PAID_HOURS_VIEW_OWN,
        PERMISSIONS.PAID_HOURS_VIEW_ALL,
        PERMISSIONS.PAID_HOURS_MANAGE,
        PERMISSIONS.ORG_VIEW,
        PERMISSIONS.ORG_MANAGE,
        PERMISSIONS.RECRUITMENT_VIEW,
        PERMISSIONS.RECRUITMENT_MANAGE,
        PERMISSIONS.RECRUITMENT_CONFIG,
        PERMISSIONS.NOTICE_VIEW, PERMISSIONS.NOTICE_ACKNOWLEDGE, PERMISSIONS.NOTICE_MANAGE,
        PERMISSIONS.SOP_VIEW,
        PERMISSIONS.SOP_ACKNOWLEDGE,
        PERMISSIONS.SOP_MANAGE,
        PERMISSIONS.SOP_ASSIGN,
        PERMISSIONS.SOP_COMPLIANCE_VIEW,
        PERMISSIONS.SOP_CONFIG,
        PERMISSIONS.ASSETS_VIEW, PERMISSIONS.ASSETS_CREATE, PERMISSIONS.ASSETS_EDIT,
        PERMISSIONS.ASSETS_DELETE, PERMISSIONS.ASSETS_ASSIGN, PERMISSIONS.ASSETS_EXPORT,
        PERMISSIONS.ASSETS_OVERVIEW,
        PERMISSIONS.ASSETS_MASTER, PERMISSIONS.ASSETS_VIEW_OWN,
        PERMISSIONS.ID_CATEGORIES_MANAGE, PERMISSIONS.ID_MANAGEMENT_VIEW, PERMISSIONS.ID_MANAGEMENT_MANAGE,
        PERMISSIONS.MY_IDS_VIEW_OWN,
        PERMISSIONS.TASK_VIEW_OWN, PERMISSIONS.TASK_VIEW_TEAM, PERMISSIONS.TASK_VIEW_ALL,
        PERMISSIONS.TASK_CREATE, PERMISSIONS.TASK_ASSIGN, PERMISSIONS.TASK_EDIT,
        PERMISSIONS.TASK_WORK, PERMISSIONS.TASK_REVIEW, PERMISSIONS.TASK_MANAGE,
        PERMISSIONS.TASK_REPORT_VIEW, PERMISSIONS.TASK_CONFIG,
        PERMISSIONS.ADDITIONAL_TASK_VIEW_OWN, PERMISSIONS.ADDITIONAL_TASK_VIEW_ALL,
        PERMISSIONS.ADDITIONAL_TASK_CREATE, PERMISSIONS.ADDITIONAL_TASK_MANAGE,
        PERMISSIONS.CALENDAR_VIEW_OWN, PERMISSIONS.CALENDAR_VIEW_TEAM, PERMISSIONS.CALENDAR_VIEW_ALL,
        PERMISSIONS.CALENDAR_CREATE, PERMISSIONS.CALENDAR_EDIT, PERMISSIONS.CALENDAR_DELETE,
        PERMISSIONS.PERFORMANCE_VIEW_OWN, PERMISSIONS.PERFORMANCE_VIEW_TEAM, PERMISSIONS.PERFORMANCE_VIEW_ALL,
        PERMISSIONS.PERFORMANCE_REVIEW, PERMISSIONS.PERFORMANCE_GOALS_MANAGE,
        PERMISSIONS.STAFF_DOCUMENTS_VIEW, PERMISSIONS.STAFF_DOCUMENTS_MANAGE,
        PERMISSIONS.FINANCE_VENDORS_VIEW, PERMISSIONS.FINANCE_VENDORS_CREATE,
        PERMISSIONS.FINANCE_VENDORS_EDIT, PERMISSIONS.FINANCE_VENDORS_DELETE,
        PERMISSIONS.FINANCE_PURCHASES_VIEW, PERMISSIONS.FINANCE_PURCHASES_CREATE,
        PERMISSIONS.FINANCE_PURCHASES_PAY, PERMISSIONS.FINANCE_LEDGER_VIEW,
        PERMISSIONS.FINANCE_MASTER,
        PERMISSIONS.FINANCE_REIMBURSEMENTS_MANAGE, PERMISSIONS.FINANCE_REIMBURSEMENT_REQUEST,
        PERMISSIONS.REQUIREMENTS_VIEW, PERMISSIONS.REQUIREMENTS_CREATE, PERMISSIONS.REQUIREMENTS_EDIT,
        PERMISSIONS.REQUIREMENTS_DELETE, PERMISSIONS.REQUIREMENTS_APPROVE,
        PERMISSIONS.REQUIREMENTS_MASTER, PERMISSIONS.REQUIREMENTS_OVERVIEW,
        PERMISSIONS.SUBSCRIPTIONS_VIEW, PERMISSIONS.SUBSCRIPTIONS_CREATE, PERMISSIONS.SUBSCRIPTIONS_EDIT,
        PERMISSIONS.SUBSCRIPTIONS_DELETE, PERMISSIONS.SUBSCRIPTIONS_RENEW, PERMISSIONS.SUBSCRIPTIONS_CANCEL,
        PERMISSIONS.SUBSCRIPTIONS_EXPORT, PERMISSIONS.SUBSCRIPTIONS_OVERVIEW, PERMISSIONS.SUBSCRIPTIONS_MASTER,
        PERMISSIONS.TECH_SUPPORT_VIEW_OWN, PERMISSIONS.TECH_SUPPORT_VIEW_ALL, PERMISSIONS.TECH_SUPPORT_CREATE,
        PERMISSIONS.TECH_SUPPORT_UPDATE, PERMISSIONS.TECH_SUPPORT_DELETE, PERMISSIONS.TECH_SUPPORT_ASSIGN,
        PERMISSIONS.TECH_SUPPORT_ESCALATE, PERMISSIONS.TECH_SUPPORT_CLOSE, PERMISSIONS.TECH_SUPPORT_MANAGE_CATEGORIES,
        PERMISSIONS.TECH_SUPPORT_MANAGE_SLA, PERMISSIONS.TECH_SUPPORT_VIEW_REPORTS,
        PERMISSIONS.REPORTS_VIEW, PERMISSIONS.REPORTS_EXPORT, PERMISSIONS.REPORTS_GOALS_VIEW,
        PERMISSIONS.DELETE_ACCESS_MANAGE,
        PERMISSIONS.GOALS_VIEW_OWN, PERMISSIONS.GOALS_VIEW_TEAM, PERMISSIONS.GOALS_VIEW_ALL,
        PERMISSIONS.GOALS_CREATE, PERMISSIONS.GOALS_ASSIGN, PERMISSIONS.GOALS_EDIT,
        PERMISSIONS.GOALS_DELETE, PERMISSIONS.GOALS_PROGRESS_UPDATE, PERMISSIONS.GOALS_REVIEW,
        PERMISSIONS.GOALS_CONFIG,
    ],
    [ROLES.MANAGER]: [
        PERMISSIONS.STAFF_VIEW_ALL,
        PERMISSIONS.STAFF_VIEW_TEAM,
        PERMISSIONS.STAFF_EXPORT,
        PERMISSIONS.PROFILE_VIEW_OWN,
        PERMISSIONS.PROFILE_EDIT_OWN,
        PERMISSIONS.DEPARTMENTS_VIEW,
        PERMISSIONS.DESIGNATIONS_VIEW,
        PERMISSIONS.ATTENDANCE_VIEW_OWN,
        PERMISSIONS.ATTENDANCE_VIEW_TEAM,
        PERMISSIONS.ATTENDANCE_PUNCH,
        PERMISSIONS.ATTENDANCE_REGULARIZE,
        PERMISSIONS.LEAVE_VIEW_OWN,
        PERMISSIONS.LEAVE_VIEW_TEAM,
        PERMISSIONS.LEAVE_REQUEST,
        PERMISSIONS.LEAVE_APPROVE,
        PERMISSIONS.LEAVE_CANCEL,
        PERMISSIONS.LEAVE_CREDIT_VIEW,
        PERMISSIONS.SALARY_VIEW_OWN,
        PERMISSIONS.LOAN_VIEW_OWN,
        PERMISSIONS.PENALTY_VIEW_OWN,
        PERMISSIONS.PAID_HOURS_VIEW_OWN,
        PERMISSIONS.RECRUITMENT_VIEW,
        PERMISSIONS.RECRUITMENT_MANAGE,
        PERMISSIONS.NOTICE_VIEW, PERMISSIONS.NOTICE_ACKNOWLEDGE,
        PERMISSIONS.SOP_VIEW,
        PERMISSIONS.SOP_ACKNOWLEDGE,
        PERMISSIONS.SOP_MANAGE,
        PERMISSIONS.SOP_ASSIGN,
        PERMISSIONS.ASSETS_VIEW, PERMISSIONS.ASSETS_CREATE, PERMISSIONS.ASSETS_EDIT,
        PERMISSIONS.ASSETS_ASSIGN, PERMISSIONS.ASSETS_EXPORT,
        PERMISSIONS.ASSETS_OVERVIEW, PERMISSIONS.ASSETS_VIEW_OWN,
        PERMISSIONS.MY_IDS_VIEW_OWN,
        PERMISSIONS.TASK_VIEW_OWN, PERMISSIONS.TASK_VIEW_TEAM, PERMISSIONS.TASK_VIEW_ALL,
        PERMISSIONS.TASK_CREATE, PERMISSIONS.TASK_ASSIGN, PERMISSIONS.TASK_EDIT,
        PERMISSIONS.TASK_WORK, PERMISSIONS.TASK_REVIEW, PERMISSIONS.TASK_REPORT_VIEW,
        PERMISSIONS.ADDITIONAL_TASK_VIEW_OWN, PERMISSIONS.ADDITIONAL_TASK_VIEW_ALL,
        PERMISSIONS.ADDITIONAL_TASK_CREATE, PERMISSIONS.ADDITIONAL_TASK_MANAGE,
        PERMISSIONS.CALENDAR_VIEW_OWN, PERMISSIONS.CALENDAR_VIEW_TEAM,
        PERMISSIONS.CALENDAR_CREATE, PERMISSIONS.CALENDAR_EDIT, PERMISSIONS.CALENDAR_DELETE,
        PERMISSIONS.PERFORMANCE_VIEW_OWN, PERMISSIONS.PERFORMANCE_VIEW_TEAM,
        PERMISSIONS.PERFORMANCE_REVIEW, PERMISSIONS.PERFORMANCE_GOALS_MANAGE,
        PERMISSIONS.STAFF_DOCUMENTS_VIEW, PERMISSIONS.STAFF_DOCUMENTS_MANAGE,
        PERMISSIONS.FINANCE_VENDORS_VIEW, PERMISSIONS.FINANCE_VENDORS_CREATE,
        PERMISSIONS.FINANCE_PURCHASES_VIEW, PERMISSIONS.FINANCE_PURCHASES_CREATE,
        PERMISSIONS.FINANCE_PURCHASES_PAY, PERMISSIONS.FINANCE_LEDGER_VIEW,
        PERMISSIONS.FINANCE_REIMBURSEMENT_REQUEST,
        PERMISSIONS.REQUIREMENTS_VIEW, PERMISSIONS.REQUIREMENTS_CREATE, PERMISSIONS.REQUIREMENTS_EDIT,
        PERMISSIONS.REQUIREMENTS_APPROVE, PERMISSIONS.REQUIREMENTS_OVERVIEW,
        PERMISSIONS.SUBSCRIPTIONS_VIEW, PERMISSIONS.SUBSCRIPTIONS_CREATE, PERMISSIONS.SUBSCRIPTIONS_EDIT,
        PERMISSIONS.SUBSCRIPTIONS_RENEW, PERMISSIONS.SUBSCRIPTIONS_CANCEL,
        PERMISSIONS.SUBSCRIPTIONS_EXPORT, PERMISSIONS.SUBSCRIPTIONS_OVERVIEW,
        PERMISSIONS.TECH_SUPPORT_VIEW_OWN, PERMISSIONS.TECH_SUPPORT_VIEW_ALL, PERMISSIONS.TECH_SUPPORT_CREATE,
        PERMISSIONS.TECH_SUPPORT_UPDATE, PERMISSIONS.TECH_SUPPORT_ASSIGN, PERMISSIONS.TECH_SUPPORT_ESCALATE,
        PERMISSIONS.TECH_SUPPORT_CLOSE, PERMISSIONS.TECH_SUPPORT_VIEW_REPORTS,
        PERMISSIONS.REPORTS_VIEW, PERMISSIONS.REPORTS_GOALS_VIEW,
        PERMISSIONS.GOALS_VIEW_OWN, PERMISSIONS.GOALS_VIEW_TEAM, PERMISSIONS.GOALS_CREATE,
        PERMISSIONS.GOALS_ASSIGN, PERMISSIONS.GOALS_EDIT, PERMISSIONS.GOALS_DELETE,
        PERMISSIONS.GOALS_PROGRESS_UPDATE, PERMISSIONS.GOALS_REVIEW,
    ],
    [ROLES.TEAM_LEADER]: [
        PERMISSIONS.STAFF_VIEW_TEAM,
        PERMISSIONS.PROFILE_VIEW_OWN,
        PERMISSIONS.PROFILE_EDIT_OWN,
        PERMISSIONS.ATTENDANCE_VIEW_OWN,
        PERMISSIONS.ATTENDANCE_VIEW_TEAM,
        PERMISSIONS.ATTENDANCE_PUNCH,
        PERMISSIONS.LEAVE_VIEW_OWN,
        PERMISSIONS.LEAVE_VIEW_TEAM,
        PERMISSIONS.LEAVE_REQUEST,
        PERMISSIONS.LEAVE_APPROVE,
        PERMISSIONS.LEAVE_CANCEL,
        PERMISSIONS.LEAVE_CREDIT_VIEW,
        PERMISSIONS.SALARY_VIEW_OWN,
        PERMISSIONS.LOAN_VIEW_OWN,
        PERMISSIONS.PENALTY_VIEW_OWN,
        PERMISSIONS.PAID_HOURS_VIEW_OWN,
        PERMISSIONS.RECRUITMENT_VIEW,
        PERMISSIONS.NOTICE_VIEW, PERMISSIONS.NOTICE_ACKNOWLEDGE,
        PERMISSIONS.SOP_VIEW,
        PERMISSIONS.SOP_ACKNOWLEDGE,
        PERMISSIONS.ASSETS_VIEW, PERMISSIONS.ASSETS_OVERVIEW, PERMISSIONS.ASSETS_VIEW_OWN,
        PERMISSIONS.MY_IDS_VIEW_OWN,
        PERMISSIONS.TASK_VIEW_OWN, PERMISSIONS.TASK_VIEW_TEAM,
        // TASK_CREATE was granted in the DB by migration 101 but never added here, so a
        // fresh install seeded from this list had no task-creating team leaders. Listed
        // now alongside TASK_REVIEW, which a leader needs to review what they assigned.
        PERMISSIONS.TASK_CREATE,
        PERMISSIONS.TASK_WORK, PERMISSIONS.TASK_REVIEW,
        PERMISSIONS.ADDITIONAL_TASK_VIEW_OWN, PERMISSIONS.ADDITIONAL_TASK_CREATE,
        PERMISSIONS.CALENDAR_VIEW_OWN,
        PERMISSIONS.CALENDAR_CREATE, PERMISSIONS.CALENDAR_EDIT, PERMISSIONS.CALENDAR_DELETE,
        PERMISSIONS.PERFORMANCE_VIEW_OWN, PERMISSIONS.PERFORMANCE_VIEW_TEAM,
        PERMISSIONS.STAFF_DOCUMENTS_VIEW,
        PERMISSIONS.FINANCE_REIMBURSEMENT_REQUEST,
        PERMISSIONS.REQUIREMENTS_VIEW, PERMISSIONS.REQUIREMENTS_CREATE, PERMISSIONS.REQUIREMENTS_OVERVIEW,
        PERMISSIONS.SUBSCRIPTIONS_VIEW, PERMISSIONS.SUBSCRIPTIONS_OVERVIEW,
        PERMISSIONS.TECH_SUPPORT_VIEW_OWN, PERMISSIONS.TECH_SUPPORT_VIEW_ALL, PERMISSIONS.TECH_SUPPORT_CREATE,
        PERMISSIONS.TECH_SUPPORT_UPDATE, PERMISSIONS.TECH_SUPPORT_ESCALATE,
        PERMISSIONS.GOALS_VIEW_OWN, PERMISSIONS.GOALS_VIEW_TEAM, PERMISSIONS.GOALS_CREATE,
        PERMISSIONS.GOALS_ASSIGN, PERMISSIONS.GOALS_EDIT,
        PERMISSIONS.GOALS_PROGRESS_UPDATE, PERMISSIONS.GOALS_REVIEW,
    ],
    [ROLES.USER]: [
        PERMISSIONS.PROFILE_VIEW_OWN,
        PERMISSIONS.PROFILE_EDIT_OWN,
        PERMISSIONS.ATTENDANCE_VIEW_OWN,
        PERMISSIONS.ATTENDANCE_PUNCH,
        PERMISSIONS.LEAVE_VIEW_OWN,
        PERMISSIONS.LEAVE_REQUEST,
        PERMISSIONS.LEAVE_CANCEL,
        PERMISSIONS.LEAVE_CREDIT_VIEW,
        PERMISSIONS.SALARY_VIEW_OWN,
        PERMISSIONS.LOAN_VIEW_OWN,
        PERMISSIONS.PENALTY_VIEW_OWN,
        PERMISSIONS.PAID_HOURS_VIEW_OWN,
        PERMISSIONS.NOTICE_VIEW, PERMISSIONS.NOTICE_ACKNOWLEDGE,
        PERMISSIONS.SOP_VIEW,
        PERMISSIONS.SOP_ACKNOWLEDGE,
        PERMISSIONS.ASSETS_VIEW, PERMISSIONS.ASSETS_VIEW_OWN,
        PERMISSIONS.MY_IDS_VIEW_OWN,
        PERMISSIONS.TASK_VIEW_OWN,
        PERMISSIONS.TASK_WORK,
        PERMISSIONS.ADDITIONAL_TASK_VIEW_OWN, PERMISSIONS.ADDITIONAL_TASK_CREATE,
        PERMISSIONS.CALENDAR_VIEW_OWN,
        PERMISSIONS.CALENDAR_CREATE, PERMISSIONS.CALENDAR_EDIT, PERMISSIONS.CALENDAR_DELETE,
        PERMISSIONS.PERFORMANCE_VIEW_OWN,
        PERMISSIONS.FINANCE_REIMBURSEMENT_REQUEST,
        PERMISSIONS.REQUIREMENTS_VIEW, PERMISSIONS.REQUIREMENTS_CREATE,
        PERMISSIONS.SUBSCRIPTIONS_VIEW,
        PERMISSIONS.TECH_SUPPORT_VIEW_OWN, PERMISSIONS.TECH_SUPPORT_CREATE, PERMISSIONS.TECH_SUPPORT_UPDATE,
        PERMISSIONS.GOALS_VIEW_OWN, PERMISSIONS.GOALS_CREATE, PERMISSIONS.GOALS_PROGRESS_UPDATE,
    ],
};
//# sourceMappingURL=permissions.js.map